/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Pain from './pain';
import PainDetail from './pain-detail';
import PainUpdate from './pain-update';
import PainDeleteDialog from './pain-delete-dialog';

const PainRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Pain />} />
    <Route path="new" element={<PainUpdate />} />
    <Route path=":id">
      <Route index element={<PainDetail />} />
      <Route path="edit" element={<PainUpdate />} />
      <Route path="delete" element={<PainDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PainRoutes;
